import React from 'react'
import { ControlledHiddenInput } from 'transfix-form/components'
import { Box } from 'transfix-ui/core'
import makeStyles from 'transfix-ui/core/styles/makeStyles'
import { brandColors, Radio, Tag, TAG_SIZE, TAG_STYLE } from 'transfix-ui'
import { useShareLoadViaSmsModalFormContext } from './useShareLoadViaSmsModalForm'

const useShareLoadViaSmsFormStyles = makeStyles(({ spacing }) => ({
  root: {},
  card: {
    padding: spacing(2),
    background: brandColors.coolGray1,
    borderRadius: spacing(2),
    marginTop: spacing(2),
  },
  row: {
    display: 'flex',
    flexGap: spacing(2),
    alignItems: 'center',
  },
  bold: {
    [`& > span`]: { fontWeight: 'bold' },
  },
}))

export const ShareLoadViaSmsModalForm = () => {
  const { control, setValue, watch } = useShareLoadViaSmsModalFormContext()
  const isOneTime = watch('oneTime')
  const classes = useShareLoadViaSmsFormStyles()
  return (
    <form data-test='ShareLoadViaSmsModalForm'>
      <ControlledHiddenInput name='oneTime' control={control} defaultValue={false} />
      <Box className={classes.card} onClick={() => setValue('oneTime', false)}>
        <div className={classes.row}>
          <Radio
            label='Ask for status updates throughout load'
            checked={!isOneTime}
            className={classes.bold}
          />
          <Tag tagStyle={TAG_STYLE.success} size={TAG_SIZE.xsmall} label='Recommended' />
        </div>
        <p>
          We’ll automatically text your driver a timely reminder at every stop to update their
          status. You’ll receive an email when they arrive and depart each pickup and dropoff.{' '}
        </p>
      </Box>
      <Box className={classes.card} onClick={() => setValue('oneTime', true)}>
        <Radio label='Send one-time link' checked={isOneTime} className={classes.bold} />
      </Box>
    </form>
  )
}
